import * as React from 'react';

import { useIntl } from 'react-intl';
import { Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout.tsx';
import SidePanel from 'src/components/sidePanel/SidePanel.tsx';
import { useGetParking } from 'src/features/parkingManagement/api/useGetParking';
import ParkingSidePanel from 'src/features/parkingManagement/components/ParkingSidePanel.tsx';
import { useParkingStatus } from 'src/features/parkingManagement/hooks/useParkingStatus';
import { RESERVATION_TYPE } from 'src/features/reservations/types/reservationType';
import { reservationMessages } from 'src/features/reservations/utils/messages';
import { useMediaQuery } from 'src/hooks/use-media-query.ts';
import { Dialog, DialogContent } from 'src/registry/ui/Dialog.tsx';
import { useTitleStore } from 'src/stores/useTitleStore';

const ParkingLayout = () => {
    const { parkingId } = useParams();

    const { reservationType } = useParams();
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();
    const { available } = useParkingStatus();

    const { data } = useGetParking({
        parkingId: parkingId || '',
        config: {
            enabled: !!parkingId && available,
        },
    });

    const isMobile = useMediaQuery('(max-width: 639px)');

    React.useEffect(() => {
        if (reservationType) {
            formatMessage(reservationMessages[reservationType as RESERVATION_TYPE]);
        } else if (data?.name) {
            data.name;
        }
        return () => {
            removeTitle();
        };
    }, [reservationType, data?.name, formatMessage, setTitle, removeTitle]);

    return (
        <div className="relative">
            {isMobile ? (
                <SidePanel name="parking-management-side-panel" variant="leftSheet">
                    <ParkingSidePanel />
                </SidePanel>
            ) : (
                <Dialog modal={false} open>
                    <DialogContent variant="leftSheetStatic" showCloseButton={false} className="overflow-y-auto">
                        <ParkingSidePanel />
                    </DialogContent>
                </Dialog>
            )}
            <MainLayout>
                <Outlet />
            </MainLayout>
        </div>
    );
};

export default ParkingLayout;
